
import { Component, Prop, Vue } from 'vue-property-decorator'

import { applyPromoCode } from '@/helpers/PromoCodes'
import { promoCodeErrorMessage } from '@/helpers/PromoCodesHelper'
import { randomIdentifier } from '@/helpers/StringHelpers'
import { reportFormValidity } from '@/helpers/Validation'

import store from '@/store/store'

@Component({ name: 'ApplyPromoCodes' })
export default class extends Vue {
  @Prop({ default: false })
  submitDisabled: boolean

  rawValue: string = ''
  applying: boolean = false
  error: string | null = null

  readonly errorId = 'promo-error-' + randomIdentifier()

  readonly minLength = 2

  get totalPromoDiscounts() {
    return store.getters['Cart/totalPromoDiscounts']
  }

  get value() {
    return this.rawValue.trim()
  }

  apply() {
    this.applying = true
    this.error = null
    reportFormValidity(this.$refs.form as HTMLFormElement)
      .then(() => applyPromoCode(this.value))
      .then(() => {
        this.rawValue = ''
      })
      .catch((error) => {
        const input = this.$refs.input as HTMLInputElement
        this.error = promoCodeErrorMessage(this.value, error, input)

        if (this.error === this.$t('applyPromoCodes.unknownErrorMessage')) {
          throw error
        }
      })
      .finally(() => {
        // Reset state.
        this.applying = false

        // Move focus to the invalid field so screen readers announce the
        // associated error via aria-describedby. Done here (not in catch) and
        // on nextTick so it runs after the input is re-enabled — focus() is a
        // no-op while the input is still disabled by `applying`.
        if (this.error) {
          this.$nextTick(() => (this.$refs.input as HTMLInputElement | undefined)?.focus())
        }
      })
  }

  reset() {
    this.error = null
    this.rawValue = ''
  }
}
